import gql from 'graphql-tag';

export const ACCOUNT_HIERARCHY = gql`
query getHierarchy($accountId: ID!) {
  account(id: $accountId){
    id
    accountHierarchy {
      descendantId,
      parentId,
      hasRoleInAccount,
      depth,
      sameFamily,
      ancestorType,
      descendantType,
      descendantBrandDisplayName,
      descendantBrandLogo
    }
  }
 }
 `;

export const ROOT_ACCOUNT = gql`
  query($accountId: ID!) {
    account(id: $accountId) {
      id
      type
      displayName
      brandingInformation {
        logo{
          url
        }
      }
    }
  }
`;

export const HIERARCHY_ACCOUNT = gql`
query getAccountHierarchyDetails($id: ID!) {
  accountHierarchyDetails(id: $id) {
    id
    isNewBusinessModelAccount
    plan
    subscriptionStart
    subscriptionEnd
    ownerName
    ownerEmail
    numberOfUsers
    isExternalSupport
    creditsBalance
    superMatchCreditsBalance
    latestCreditsConsumption
    demoCreditsTransferred
  }
}
`;

export const VIEWER_ROLE = gql`
query getViewer {
    viewer {
      id
      roles {
        role {
          id
          name
          displayName
        }
        account {
            id
            type
          }
      }
    }
  }
`;
